import { ThemeTypes } from "@/utils/theming";

const womenHairResultsPath = "/hair/brand/learn/results/customer-reviews/";

export const prepareLink = (link: string, theme: ThemeTypes) => {
  if (theme === "men" && link.includes(womenHairResultsPath)) {
    return link.replace("/hair/brand/learn/", "/hair/men/learn/");
  }
  const gender = theme === "men" ? "men" : "women";
  return link.replace("{gender}", gender);
};
